import { useEffect } from "react";
import { useNavigate } from "react-router";

import { mixpanelUtils } from "@/lib/mixpanel/mixpanel";
import { MIXPANEL_SCREENS } from "@/lib/mixpanel/types";
import { storage } from "@/lib/storage";

export const CatchAllPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    mixpanelUtils.trackScreenView(MIXPANEL_SCREENS.CATCH_ALL_PAGE);
  }, []);

  useEffect(() => {
    try {
      // Try sending the user to the "home" page if the user exists in local storage.
      const user = storage.getUser();
      if (user) {
        void navigate(`/companies`);
      } else {
        void navigate("/sign-in");
      }
    } catch {
      // TODO: Unified way to navigate to the sign-in page since this is a common pattern.
      void navigate("/sign-in");
    }
  }, [navigate]);

  return null;
};
